import React from 'react';

const Step4_Complete = ({ summary, clid, onRestart }) => {
  const createdDoctors = summary?.createdDoctors || 0;
  const createdSchedules = summary?.createdSchedules || 0;
  const targetClid = summary?.clid || clid || 'SGCL0002_copy';
  const steps = ['Step 1', 'Step 2', 'Step 3', 'Complete'];

  if (!summary?.success) {
    return (
      <div className="space-y-6 text-center">
        <h2 className="text-2xl font-bold text-gray-900">Step 4: Complete</h2>
        <p className="text-gray-600">
          We could not find a successful import summary. Please restart the flow and try again.
        </p>
        <button
          type="button"
          onClick={onRestart}
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Start New Import
        </button>
      </div>
    );
  }

  const handleViewDoctors = () => {
    if (!targetClid) return;
    window.location.href = `/clinics/${targetClid}#doctors`;
  };

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 4: Complete</h2>
        <p className="text-gray-600">All doctor profiles and schedules have been imported.</p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4">
        {steps.map((label, index) => (
          <div key={label} className="flex items-center gap-2">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold ${
                index === steps.length - 1 ? 'bg-green-600 text-white' : 'bg-green-200 text-green-800'
              }`}
            >
              {index === steps.length - 1 ? '✓' : index + 1}
            </div>
            <span
              className={`text-sm font-medium ${
                index === steps.length - 1 ? 'text-green-700' : 'text-green-800'
              }`}
            >
              {label}
            </span>
            {index < steps.length - 1 && <div className="hidden sm:block w-12 h-0.5 bg-green-200"></div>}
          </div>
        ))}
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center space-y-2">
        <p className="font-semibold text-green-800 text-lg">✓ Import Completed</p>
        <p className="text-green-900">
          {`Successfully created ${createdDoctors} doctor${createdDoctors === 1 ? '' : 's'} and ${createdSchedules} schedule${createdSchedules === 1 ? '' : 's'}.`}
        </p>
        {targetClid && (
          <p className="text-sm text-green-800">
            Updated clinic ID: <span className="font-mono text-green-900">{targetClid}</span>
          </p>
        )}
      </div>

      <div className="flex flex-wrap justify-center gap-4">
        <button
          type="button"
          onClick={onRestart}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Start New Import
        </button>
        {targetClid && (
          <button
            type="button"
            onClick={handleViewDoctors}
            className="px-8 py-3 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            View Doctor Page
          </button>
        )}
      </div>
    </div>
  );
};

export default Step4_Complete;

